import * as React from 'react';
import { formatDate } from '@common';
import { Combobox, ComboboxOptionProps } from '@mantine/core';
import { createLink, LinkComponent } from '@tanstack/react-router';

type ComboboxOptionComponentProps = Omit<ComboboxOptionProps, 'href'>;

const MantineComboboxOptionComponent = React.forwardRef<
  HTMLDivElement,
  ComboboxOptionComponentProps
>((props, ref) => {
  if (typeof props.value !== 'string') return null;

  return (
    <Combobox.Option ref={ref} {...props}>
      {formatDate(props.value)}
    </Combobox.Option>
  );
});

MantineComboboxOptionComponent.displayName = 'MantineComboboxOptionComponent';

const CreatedLinkComponent = createLink(MantineComboboxOptionComponent);

export const VersionSelectOption: LinkComponent<
  typeof MantineComboboxOptionComponent
> = (props) => {
  return <CreatedLinkComponent {...props} />;
};
